import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from '@/store'
import axios from 'axios';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  //base:process.env.environment === 'development' ? '/sistema-produccion/' : '/sistema-produccion/',
  base:process.env.environment === 'development' ? '/' : '/',
  routes: [
    { path: '/', redirect: '/login', },
    { path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    { path: '/login',             name: 'login',                component: () => import('@/views/Login.vue') },
    { path:'/dashboard',          name:'dashboard',             component: () => import('@/views/Dashboard.vue') },

    /* ======================================= MAESTROS - CONFIGURACIONES =========================================*/
    { path:'/barras',               name:'barras',              component: () => import('@/views/BARRA.vue') },
    { path:'/calderas',             name:'calderas',            component: () => import('@/views/Caldera.vue')},
    { path:'/clientes',             name:'clientes',            component: () => import('@/views/Mantenedores/Clientes.vue') },
    { path:'/colores',              name:'colores',             component: () => import('@/views/Color/Color.vue') },
    { path:'/conftipoproduccionmp', name:'conftipoproduccionmp',component: () => import('@/views/Tipo_Produccion_Mps/Tipo_Produccion_Mps.vue') },
    { path:'/equipoproceso',        name:'equipoproceso',       component: () => import('@/views/Equipo_Proceso/Equipo_Proceso.vue') },
    { path:'/equipos_iconos',       name:'equipos_iconos',      component: () => import('@/views/Equipo_Icono/Equipo_Icono.vue') },
    { path:'/estanques',            name:'estanques',           component: () => import('@/views/Estanque_Aceite/Estanque_Aceite.vue') },
    { path:'/estanques_externos',   name:'estanques_externos',  component: () => import('@/views/Estanque_Aceite/EstanquesExternos.vue') },
    { path:'/formulas',             name:'formulas',            component: () => import('@/views/Formula/Formula.vue') },
    { path:'/insumos',              name:'insumos',             component: () => import('@/views/Insumo_Produccion/Insumo_Produccion.vue') },
    { path:'/laboratorios',         name:'laboratorios',        component: () => import('@/views/Mantenedores/Laboratorios.vue') },
    { path:'/lineas',               name:'lineas',              component: () => import('@/views/Linea/Linea.vue') },
    { path:'/pantallaticket',       name:'pantallaticket',      component: () => import('@/views/Pantallas/Ticket_Guia.vue') },
    { path:'/pantallaparametro',    name:'pantallaparametro',   component: () => import('@/views/Pantallas/Parametros.vue') },
    { path:'/parametrodetalle',     name:'parametrodetalle',    component: () => import('@/views/Parametro_Detalle/Parametro_Detalle.vue') },
    { path:'/parametros',           name:'parametros',          component: () => import('@/views/Parametro/Parametro.vue') },
    { path:'/pozos',                name:'pozos',               component: () => import('@/views/Pozo/Pozo.vue') },
    { path:'/puntomedicion',        name:'puntomedicion',       component: () => import('@/views/Punto_Medicion/Punto_Medicion.vue') },
    { path:'/tipoequipo',           name:'tipoequipo',          component: () => import('@/views/Tipo_Equipo/Tipo_Equipo.vue') },
    { path:'/tiposmateriasprimas',  name:'tiposmateriasprimas', component: () => import('@/views/Tipo_MP/Tipo_Materia_Prima.vue') },
    { path:'/tiposproduccion',      name:'tiposproduccion',     component: () => import('@/views/Tipo_Produccion/Tipo_Produccion.vue') },
    { path:'/turnos',               name:'turnos',              component: () => import('@/views/Turno/Turno.vue') },
    { path:'/unidadmedida',         name:'unidadmedida',        component: () => import('@/views/Unidad_Medida/Unidad_Medida.vue') },
    { path:'/menus',                name:'menus',               component: () => import('@/views/Menus/Menus.vue') },
    { path:'/docs_mov',             name:'docs_mov',            component: () => import('@/views/Documentos_Movimientos/DocumentosMovimientos.vue') },

    /* ======================================= LABORAORIO =========================================*/
    { path:'/bitacora',             name:'bitacora',              component: () => import('@/views/Laboratorio/Laboratorio.vue') },
    { path:'/importarbitacora',     name:'importarbitacora',      component: () => import('@/views/Importar_Bitacora/Importar_Bitacora.vue') },
    { path:'/registroslaboratorio', name:'registroslaboratorio',  component: () => import('@/views/Consulta/Registro_Laboratorio.vue') },
    { path:'/registroslaboratorio_kiosko', name:'registroslaboratoriokiosko',  component: () => import('@/views/Consulta/Registro_Laboratorio_kiosko.vue') },


    /* ======================================= PRODUCCION HARINA =========================================*/
    { path:'/calendario_produccion',  name:'calendario_produccion',   component: () => import('@/views/Calendario_Produccion/Calendario_Produccion.vue') },
    { path:'/consolidado_diario',     name:'consolidado_diario',      component: () => import('@/views/Produccion_Consolidada/Consolidado_Diario.vue') },
    { path:'/despacho_harina',        name:'despacho_harina',         component: () => import('@/views/Despacho_Harina/Despacho_Harina.vue') },
    { path:'/despachos_harina',       name:'despachos_harina',        component: () => import('@/views/Despacho_Harina/Despacho.vue')  },
    { path:'/equipoestadoreporte',    name:'equipoestadoreporte',     component: () => import('@/views/Reporte_Estado_Equipos/Reporte_Estado_Equipos') },
    { path:'/equipolista',            name:'equipolista',             component: () => import('@/views/Equipo_lista/Equipo_Lista') },
    { path:'/equipoplanta',           name:'equipoplanta',            component: () => import('@/views/Equipo_Planta/Equipo_Planta') },
    { path:'/jumbos',                 name:'jumbos',                  component: () => import('@/views/Jumbos/Jumbos.vue') },
    { path:'/jumbos_reproceso',       name:'jumbos_reproceso',        component: () => import('@/views/Reporte_Jumbos_Reproceso/Reporte_Jumbos_Reproceso.vue') },
    { path:'/lotes',                  name:'lotes',                   component: () => import('@/views/Lotes/Lotes.vue') },
    { path:'/produccion_consolidada', name:'produccion_consolidada',  component: () => import('@/views/Produccion_Consolidada/Produccion_Consolidada.vue') },
    { path:'/produccion_diaria',      name:'produccion_diaria',       component: () => import('@/views/Produccion_Diaria/Produccion_Diaria.vue') },
    { path:'/importar_harina',        name:'importar_harina',         component: () => import('@/views/Produccion_Diaria/ImportarProducciones.vue') },
    { path:'/consolidado_anual',      name:'consolidado_anual',       component: () => import('@/views/Reporte_Consolidado_Anual/ReporteConsolidadoAnual.vue') },
    { path:'/produccion_harina',      name:'produccion_harina',       component: () => import('@/views/Reporte_Produccion_Harina/Reporte_Produccion_Harina.vue') },
    { path:'/produccion_turno',       name:'produccion_turno',        component: () => import('@/views/Produccion_Turno/Produccion_Turno.vue') },
    { path:'/stockinsumos',           name:'stockinsumos',            component: () => import('@/views/Stock_Insumos/Stock_Insumos.vue') },
    { path:'/stock_aceite_estanques', name:'stock_aceite_estanques',  component: () => import('@/views/Reporte_Stock_Aceite/Reporte_Stock_Aceite.vue') },

    /* ======================================= PRODUCCION ACEITE =========================================*/
    { path:'/despacho_aceite',      name:'despacho_aceite',     component: () => import('@/views/Despacho_Aceite/Despacho_Aceite.vue') },
    { path:'/aceite_reproceso',      name:'aceite_reproceso',     component: () => import('@/views/Aceite/Aceite_Reproceso.vue') },
    { path:'/despacho_aceite_r',    name:'despacho_aceite_r',   component: () => import('@/views/Produccion_Aceite/Despachos_Aceite_Romana.vue') },
    { path:'/importaraceite',       name:'importaraceite',      component: () => import('@/views/Estanque_Aceite/Importar_Aceite.vue') },
    { path:'/produccion_aceite',    name:'produccion_aceite',   component: () => import('@/views/Produccion_Aceite/Produccion_Aceite.vue') },
    { path:'/stockaceite',          name:'stockaceite',         component: () => import('@/views/Stock_Aceite/Stock_Aceite.vue') },
    { path:'/importaraceites',      name:'importaraceites',     component: () => import('@/views/Aceite/Importar_Aceite_Sernapesca.vue') },
    { path:'/reporte_aceites',      name:'reporte_aceites',     component: () => import('@/views/Aceite/ReporteTrazaAceite.vue') },
    { path:'/merma_aceites',        name:'merma_aceites',       component: () => import('@/views/Aceite/MermaAceite.vue') },
    { path:'/foliacion_aceites',    name:'foliacion_aceites',   component: () => import('@/views/Aceite/FoliacionAceite.vue') },

    { path:'/registro_folios',    name:'registro_folios',   component: () => import('@/views/Folios/RegistroFolios.vue') },
    
    /* =================================== PRODUCCION PLANTA HIDROLIZADO ==================================*/
    { path:'/planta_ensilaje',      name:'planta_ensilaje',     component: () => import('@/views/PlantaHidrolizado/ProduccionDiariaH.vue') },


    /* ======================================= REPORTES =========================================*/
    { path:'/alarmas_dia',          name:'alarmas_dia',         component: () => import('@/views/Alarmas_Dia/Alarmas_Dia.vue') },
    { path:'/params_avg',           name:'params_avg',          component: () => import('@/views/Alarmas_Dia/ReporteParametrosAvg.vue') },
    { path:'/grafico_parametros',   name:'grafico_parametros',  component: () => import('@/views/Grafico_Parametros/Grafico_Parametros.vue') },
    { path:'/informe_lotes',        name:'informe_lotes',       component: () => import('@/views/Reporte_Lotes/Reporte_Lotes.vue') },
    { path:'/personalizado',        name:'personalizado',       component: () => import('@/views/Informes/Personalizado.vue') },
    { path:'/stock_repaso_jumbos',  name:'stock_repaso_jumbos', component: () => import('@/views/Reporte_Stock_Repaso/Reporte_Stock_Repaso.vue') },
    { path:'/stock_harina',         name:'stock_harina',        component: () => import('@/views/Reporte_Stock_Harina/Reporte_Stock_Harina.vue') },
    { path:'/aceite_bodegas',       name:'aceite_bodegas',      component: () => import('@/views/Aceite/DespachosAceiteBodegas.vue') },

    
    /* ================================================ PAC INSPECCIONES =========================================*/
    { path:'/areas_responsables',      name:'areas_responsables',      component: () => import('@/views/Pac_Inspeccion/Mantenedor_Areas.vue') },
    { path:'/causas_problema',         name:'causas_problema',         component: () => import('@/views/Pac_Inspeccion/Mantenedor_Pac_Causas.vue') },
    { path:'/dashboard_inspeccion',    name:'dashboard_inspeccion',    component: () => import('@/views/Pac_Inspeccion/Dashboard.vue') },
    { path:'/inspeccion_pac',          name:'inspeccion_pac',          component: () => import('@/views/Pac_Inspeccion/Inspeccion_Pac.vue') },
    { path:'/inspeccion_lista',        name:'inspeccion_lista',        component: () => import('@/views/Pac_Inspeccion/Inspeccion_Lista.vue') },
    { path:'/sectores_inspeccion_pac', name:'sectores_inspeccion_pac', component: () => import('@/views/Pac_Inspeccion/Mantenedor_Sectores_Inspeccion.vue') },
    
    /**=============================== BODEGA PLANTA ================================================*/
    { path:'/asignar_despacho_bodega', name:'asignar_despacho_bodega',  component: () => import('@/views/Despacho_Bodega_Romana/Despacho_Bodega_Romana.vue')  },
    { path:'/despachos_harina/:id',    name:'despachos_harina_detalle', component: () => import('@/views/Despacho_Harina/DetalleDespachoHarina.vue') },
    { path:'/despacho_recepcion/:id',  name:'despacho_recepcion',       component: ()=>import('@/views/Despacho_Harina/DespachoRecepcion.vue') },
    { path:'/importarmaxisacos',       name:'importarmaxisacos',        component: () => import('@/views/Movimiento_Bodegas/Importar_Maxisacos.vue') },
    { path:'/movimientos',             name:'movimientos',              component: () => import('@/views/Movimiento_Bodegas/Listado.vue') },
    { path:'/movimientos/:id',         name:'movimientos_detalle',      component: () => import('@/views/Movimiento_Bodegas/Detalle.vue') },
    { path:'/reporte_despacho_harina', name:'reporte_despacho_harina',  component: () => import('@/views/Reporte_Despacho_Harina/Reporte_Despacho_Harina.vue') },
    { path:'/reporte_reproceso',       name:'reporte_reproceso',        component: () => import('@/views/Movimiento_Bodegas/Reporte_Stock_Bodega.vue') },
    { path:'/salida_reproceso',        name:'salida_reproceso',         component: () => import('@/views/Movimiento_Bodegas/Salida_Reproceso.vue') },
    { path:'/editar_salida/:id',       name:'editar_salida',            component: () => import('@/views/Movimiento_Bodegas/Editar_Salida.vue')  },


    /**=============================== BODEGAS ================================================*/
    { path:'/traslados_bodegas',        name:'traslados_bodegas',         component: () => import('@/views/Movimiento_Bodegas/Traslados_Bodegas.vue') },
    { path:'/envio_a_planta',           name:'envio_a_planta',            component: () => import('@/views/Bodegas/EnvioBodegaCentral.vue') },
    { path:'/exportacion_venta',        name:'exportacion_venta',         component: () => import('@/views/Bodegas/ExportacionVenta.vue') },
    { path:'/salida_transformar_harina',name:'salida_transformar_harina', component: () => import('@/views/Bodegas/SalidaTransformar.vue') },
    { path:'/stock_bodegas',            name:'stock_bodegas',             component: () => import('@/views/Movimiento_Bodegas/Reporte_Stock_Bodega.vue') },
    { path:'/crear_preembarques',       name:'crear_preembarques',        component: () => import('@/views/Preembarques/Preembarques.vue') },
    { path:'/preembarques',             name:'preembarques',              component: () => import('@/views/Preembarques/ListaPreembarques.vue') },
    { path:'/editar_preembarque/:id',   name:'editar_preembarque',        component: () => import('@/views/Preembarques/ModificarPreembarque.vue') },
    
    { path:'/analisis_externo',        name:'analisis_externo',         component: () => import('@/views/Laboratorio/AnalisisExterno.vue') },
    

    /**=============================== TRAZABILIDAD / CALIDAD ================================================*/
    { path:'/despachos_pcc4',          name:'despachos_pcc4',          component: () => import('@/views/Despacho_Harina/DespachoPcc4.vue')  },
    { path:'/generar_planilla',        name:'generar_planilla',        component: () => import('@/views/Despacho_Harina/GenerarPlanilla.vue')  },
    { path:'/planilla_proceso',        name:'planilla_proceso',        component: () => import('@/views/Planillas/Proceso.vue') },
    { path:'/trazabilidad_harina',     name:'trazabilidad_harina',     component: () => import('@/views/Trazabilidad/Trazabilidad_Harina.vue')  },
    { path:'/trazabilidad_dia',        name:'trazabilidad_dia',        component: () => import('@/views/Trazabilidad/Trazabilidad_Dia.vue')  },

    { path: '*',       redirect: '/login' },

    { path:'/horas_operativas',        name:'horas_operativas',        component: () => import('@/views/Horas_Operativas/HorasOperativas.vue')  },
    { path:'/consumos',                name:'consumos',                component: () => import('@/views/Consumos/RegistroConsumos.vue')  },
    { path:'/importar_traza_thno',     name:'importar_traza_thno',     component: () => import('@/views/Importar_Traza/Importar_Traza_Thno.vue')  },
    { path:'/saldos',                  name:'saldos',                  component: () => import('@/views/Saldos/Saldos.vue')  },

  ]
})

const ifNotAuthenticated = (to, from, next) => {
  if (!store.state.authenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.state.authenticated) {
    next()
    return
  }
  next('/login')
}



//funcion que permite controlar el acceso a las rutas del sistema
router.beforeEach(async (to, from, next) => {
  //console.log('autenticado  token: '+store.state.authenticated);
  //console.log('path',to.fullPath);
  // if(to.fullPath === '/'){
  //   if(store.state.authenticated){
  //     //si esta autenticado
  //     next('/dashboard')
  //   }else{
  //     next('/login')
  //   }
  // }
  // else{
  //   if(to.fullPath === '/login'){
  //     if(store.state.authenticated){
  //         next('/dashboard')
  //     }else{
  //       next('/login')
  //     }
  //   }else{
  //     next()
  //   }

  // }
  // if(state.store.authenticated){

  // }
  // console.log('authenticated',store.state.authenticated)

  //rutas protegidas donde se debe estar autenticado para acceder
  const protected_routes = ['/aceite_bodegas','/alarmas_dia','/analisis_externo','/areas_responsables',
  '/asignar_despacho_bodega','/bitacora','/calendario_produccion','/causas_problema','/clientes',
  '/colores','/consolidado_diario','/crear_preembarques','/dashboard','/dashboard_inspeccion',
  '/despacho_aceite','/despacho_aceite_r','/despacho_harina','/despachos_pcc4','/despachos_harina',
  '/despacho_recepcion','/editar_preembarque','/editar_salida','/envio_a_planta','/equipoestadoreporte',
  '/equipolista','/equipoplanta','/equipoproceso', '/estanques','/estanques_externos','/exportacion_venta',
  '/foliacion_aceites','/formulas','/generar_planilla','/grafico_parametros','/importar aceite','/importaraceites',
  '/importarbitacora','/importarmaxisacos','/informe_lotes','/inspeccion_lista','/inspeccion_pac','/insumos',
  '/jumbos','/jumbos_reproceso','/laboratorios','/lineas','/lotes','/merma_aceites','/movimientos',
  '/pantalla_parametro', '/pantalla_ticket','/parametrodetalle','/parametros','/personalizado','/planilla_proceso',
  '/planta_ensilaje','/pozos','/preembarques','/produccion_aceite','produccion_consolidada','/produccion_diaria',
  '/produccion_harina','/produccion_turno','/puntomedicion','/reporte_aceites','/registroslaboratorio',
  '/reporte_despacho_harina','/reporte_reproceso','/salida_reproceso','/salida_transformar_harina',
  '/sectores_inspeccion_pac','/stockaceite','/stock_bodegas','/stock_aceite_estanques','/stock_harina',
  '/stockinsumos','/stock_repaso_jumbos','/tipoequipo','/tiposmateriasprimas','/tiposproduccion',
  '/traslados_bodegas','/trazabilidad_dia','/trazabilidad_harina','/turnos','/unidadmedida'];

  //'/indicadordetalle','/conftipoproduccionmp','/personalizado','/equipos_iconos',

  let founded = false;
  protected_routes.forEach(route => {
    if(to.fullPath === route){
      //console.log('encontro',route);
      founded = true;
    }
  });
  //console.log('se ejecuta antes?',founded);

  // para interceptar sesión expirada y redirigir al login
  axios.interceptors.response.use(
    response => response,
    error => {
      if (error.response.status === 401) {
        // sesión expirada, redireccionar a la página de inicio de sesión
        if (router.currentRoute.path !== '/login') {
          console.log("devuelto al login")
          store.commit('removeSession', store.state);
          //router.push('/login');
        }
      }
      return Promise.reject(error);
    }
  );

  if(founded){
    if(!store.state.authenticated){
      next('/login');
    }
    else{
      next();
    }
  }
  else{
    // if(to.fullPath === '/login' || to.fullPath === '/'){
    //   console.log('entra aqui',to.fullPath);
    //     if(store.state.authenticated){
    //       next('/dashboard')
    //     }
    //     else{
    //       next()
    //     }
    // }
    // else{
    //   next()
    // }
    if(to.fullPath === '/' || to.fullPath === '/login'){
      if(store.state.authenticated){
        next('/dashboard');
      }else{
        next();
      }
    }else{
      next();
    }
  }
});

export default router;
